export default function ServicesIntro() {
  return (
    <section className="py-14 md:py-18 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="max-w-3xl mx-auto text-center">
          <div className="inline-flex items-center gap-2 bg-[#EAF5E1] text-[#7FBF3F] text-xs font-semibold px-4 py-1.5 rounded-full mb-5 uppercase tracking-wider">
            <i className="ri-service-line"></i>What We Offer
          </div>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#212121] mb-5 leading-tight" style={{ fontFamily: "'Playfair Display', serif" }}>
            Comprehensive Real Estate Solutions in Bengaluru
          </h2>
          <p className="text-gray-600 text-base md:text-lg leading-relaxed mb-8">
            Urban Infra offers end-to-end real estate development and consultation services on Sarjapur Road in Bangalore, with a focus on practical value, quality execution, and customer trust. Whether you are looking for a villa plot or expert guidance on your next property investment, we are here to help you make the right decision with confidence.
          </p>
          <a href="/services#enquire" className="inline-flex items-center gap-2 bg-[#7FBF3F] hover:bg-[#6aaa32] text-white text-sm font-semibold px-7 py-3 rounded-lg transition-colors cursor-pointer whitespace-nowrap">
            <i className="ri-team-line"></i>Talk to Our Team
          </a>
        </div>
      </div>
    </section>
  );
}
